import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSession } from './use-agent';

export function RequireAgent() {
  const { session } = useSession();
  const location = useLocation();

  if (session.status === 'restoring') {
    return <p className="p-8 text-sm text-slate-500">Checking your access key…</p>;
  }
  if (session.status === 'signed-out') {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
